class HangTagDetail extends HTMLElement {
  constructor() {
    super();
    this.splide_selector = "data-content";
    this.splide_containers = [...this.querySelectorAll(`[${this.splide_selector}]`)];
    this.button_selector = "data-button";
    this.buttons = [...this.querySelectorAll(`[${this.button_selector}]`)];
    this.init();

    if (Shopify.designMode) {
      document.addEventListener("shopify:section:load", function (e) {
        const hangTagDetail = e.target.querySelector("hang-tag-detail");
        if (hangTagDetail) hangTagDetail.init();
      });

      document.addEventListener("shopify:block:select", (e) => {
        const block_carousel = document.querySelector(`[data-block-id="${e.detail.blockId}"]`);
        if (block_carousel) {
          const hangTagDetail = block_carousel.closest("hang-tag-detail");
          hangTagDetail.init();
          block_carousel.click();
        }
      });

      document.addEventListener("shopify:section:deselect", (e) => {
        const hangTagDetail = e.target.querySelector("hang-tag-detail");
        if (hangTagDetail) hangTagDetail.init();
      });
    }
  }

  init() {
    this.buttons.forEach((button) => {
      button.addEventListener("click", this.onButtonClick.bind(this));
    });
    this.buttons[0].click();
  }

  onButtonClick(event) {
    const button = event.target;
    const clicked_index = button.dataset.button;
    this.buttons.forEach((e, i) => {
      const button_index = e.dataset.button;
      if (clicked_index == button_index) e.classList.add("active");
      else e.classList.remove("active");
    });
    this.splide_containers.forEach((e, i) => {
      const splide_index = e.dataset.content;
      if (clicked_index == splide_index) e.classList.remove("hidden");
      else e.classList.add("hidden");
    });
  }
}

if (!customElements.get("hang-tag-detail")) customElements.define("hang-tag-detail", HangTagDetail);
